import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setMsg(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Recuperar acesso" testid="admin-forgot-page">
      {msg ? (
        <p data-testid="forgot-success" className="text-center text-zinc-300 leading-relaxed">{msg}</p>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <p className="text-sm text-zinc-400">Informe o e-mail do administrador. Enviaremos um link válido por 1 hora.</p>
          <div className="space-y-2">
            <Label htmlFor="femail">E-mail</Label>
            <Input id="femail" data-testid="forgot-input-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="forgot-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="forgot-submit-btn" className="btn-gold w-full h-12">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Enviar link"}
          </button>
        </form>
      )}
      <Link to="/admin/login" className="block text-center text-sm text-zinc-400 hover:text-[#E6C687] mt-6" data-testid="forgot-back-link">Voltar ao login</Link>
    </AuthShell>
  );
}
